import React, { Component } from 'react';

import APIDocsCurl from 'common/developers/docs/api/APIDocsCurl';
import APIDocsMethod from 'common/developers/docs/api/APIDocsMethod';
import Highlight from 'common/developers/docs/api/Highlight';

import APIDocsBlock from '../APIDocsBlock';
import APIDocsTable from '../APIDocsTable';

export default class APIDocsCreateTagBlock extends Component {
  render() {
    return (
      <APIDocsBlock>
        <div>
          <div className="heading">Create tag</div>
          <div className="text">Creates a new tag.</div>
          <APIDocsTable
            title="Arguments"
            rows={[
              {
                description: 'Your secret API key.',
                heading: 'apiKey',
                subheading: 'string',
              },
              {
                description: 'The unique identifier of the board the tag should be created for.',
                heading: 'boardID',
                subheading: 'string',
              },
              {
                description: 'The name of the tag. Must be between 1 and 30 characters long.',
                heading: 'name',
                subheading: 'string',
              },
            ]}
          />
          <div className="subheading">Returns</div>
          <div className="text">
            Returns the tag object, if it was successfully created or already exists.
          </div>
        </div>
        <div>
          <div className="text">Endpoint</div>
          <Highlight lang="http">https://canny.io/api/v1/tags/create</Highlight>
          <APIDocsMethod />
          <APIDocsCurl
            path="https://canny.io/api/v1/tags/create"
            body={`\\
    -d apiKey=YOUR_API_KEY \\
    -d boardID=553c3ef8b8cdcd1501ba4400 \\
    -d name="New Tag"`}
          />
          <div className="text">Example Response</div>
          <Highlight lang="json">
            {`{
  "id": "553c3ef8b8cdcd1501ba12bb",
  "board": {
    "created": "2017-08-30T13:32:01.000Z",
    "id": "553c3ef8b8cdcd1501ba4400",
    "name": "Feature Requests",
    "postCount": 99,
    "url": "https://your-company.canny.io/admin/board/feature-requests"
  },
  "created": "2017-08-30T13:32:01.000Z",
  "name": "Example Tag Name",
  "postCount": 12,
  "url": "https://your-company.canny.io/admin/board/feature-requests?tag=example-tag-name"
}`}
          </Highlight>
        </div>
      </APIDocsBlock>
    );
  }
}
